import type { IExportIconProps } from './helpers';

export const ExportIcon = ({ variant = 'default', ...props }: IExportIconProps) => {
	if (variant === 'default')
		return (
			<svg
				width='15'
				height='16'
				viewBox='0 0 15 16'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...props}
			>
				<path
					d='M7.49984 1.8418C4.16529 1.8418 1.45898 4.5481 1.45898 7.88265C1.45898 11.2172 4.16529 13.9235 7.49984 13.9235C10.8344 13.9235 13.5407 11.2172 13.5407 7.88265C13.5407 4.5481 10.8344 1.8418 7.49984 1.8418ZM10.6713 8.082C10.6713 8.32967 10.4659 8.53506 10.2182 8.53506C9.97055 8.53506 9.76516 8.32967 9.76516 8.082V6.25766L5.10162 10.9212C5.01101 11.0118 4.89623 11.0541 4.78145 11.0541C4.66668 11.0541 4.5519 11.0118 4.46129 10.9212C4.2861 10.746 4.2861 10.4561 4.46129 10.2809L9.12483 5.61733H7.30049C7.05281 5.61733 6.84742 5.41194 6.84742 5.16427C6.84742 4.91659 7.05281 4.7112 7.30049 4.7112H10.2182C10.4659 4.7112 10.6713 4.91659 10.6713 5.16427V8.082Z'
					fill='#022745'
				/>
			</svg>
		);

	return (
		<svg
			width='14'
			height='14'
			viewBox='0 0 14 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				d='M8.75008 13.2702H5.25008C2.08258 13.2702 0.729248 11.9168 0.729248 8.74935V5.24935C0.729248 2.08185 2.08258 0.728516 5.25008 0.728516H8.16675C8.40592 0.728516 8.60425 0.926849 8.60425 1.16602C8.60425 1.40518 8.40592 1.60352 8.16675 1.60352H5.25008C2.56091 1.60352 1.60425 2.56018 1.60425 5.24935V8.74935C1.60425 11.4385 2.56091 12.3952 5.25008 12.3952H8.75008C11.4392 12.3952 12.3959 11.4385 12.3959 8.74935V5.83268C12.3959 5.59352 12.5942 5.39518 12.8334 5.39518C13.0726 5.39518 13.2709 5.59352 13.2709 5.83268V8.74935C13.2709 11.9168 11.9176 13.2702 8.75008 13.2702Z'
				fill='white'
			/>
			<path
				d='M12.8334 6.27127H10.5001C8.50508 6.27127 7.72925 5.49544 7.72925 3.50044V1.16711C7.72925 0.992108 7.83425 0.828774 7.99758 0.764608C8.16091 0.694608 8.34758 0.735441 8.47591 0.857941L13.1426 5.52461C13.2651 5.64711 13.3059 5.83961 13.2359 6.00294C13.1659 6.16627 13.0084 6.27127 12.8334 6.27127ZM8.60425 2.22294V3.50044C8.60425 5.00544 8.99508 5.39627 10.5001 5.39627H11.7776L8.60425 2.22294Z'
				fill='white'
			/>
		</svg>
	);
};
